import { ValueObject } from "@kernel/ddd";
import { UserType } from "@modules";
import { cloneDeep } from "lodash";

export interface ParticipantDataProps {
  displayName: string;
  type: UserType;
}

export class ParticipantData extends ValueObject<ParticipantDataProps> {
  public clone(): ParticipantData {
    const props = cloneDeep(this.props);
    return new ParticipantData(props);
  }

  public get username(): string {
    return this.props.displayName;
  }

  public get displayName(): string {
    return this.props.displayName;
  }

  public set displayName(displayName: string) {
    this.props.displayName = displayName;
  }

  public get type() {
    return this.props.type;
  }

  public set type(type: UserType) {
    this.props.type = type;
  }

  public toDto(): ParticipantDataProps {
    return this.props;
  }

  public static create(props: ParticipantDataProps): ParticipantData {
    return new ParticipantData(props);
  }
}
